import React, { useContext, useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import Location from 'components/sales/formSection/location/location';
import LeadDetails from 'components/sales/formSection/leadDetails/leadDetails';
import PocDetails from 'components/sales/formSection/pocDetails/pocDetails';
import CategoryDetails from 'components/sales/formSection/categoryDetails/categoryDetailsCorp';
import localization from 'assets/localization/localization';
import GatesForm from "components/sales/formSection/gates/addgateCorpCreateLead";
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import BulkUpload from 'components/sales/bulkUpload/bulkUpload';

const Corporate = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  createCorporateLead,
  locationPinCode,
  pincodeData,
  supplyNameFun,
  splNameData,
  getCorporateDropDown,
  corDropDownData,
  getCurrentLocation,
  latlng,
  toastMsg,
  showHideToast,
  rwaTenureFun,
  rwaTenureData,
  BulkUploadLead,
  getSampleFileLead,
  sampleData,
}) => {
  const corporateInput = {
    leadDetails: null,
    pocDetails: null,
    location: null,
    categoryDetails: null,
    gateDetails: null
  };
  const { baseUrl } = useContext(BaseUrl);
  const [corporateData, setCorporateData] = useState(corporateInput);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isbulk, setIsbulk] = useState(false);
  const [isUploaded, setIsuploaded] = useState(false);
  const [bulkFile, setBulkFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDefalut, setIsDefalut] = useState(false);

  const handleLeadSubmit = (val) => {
    setCorporateData({ ...corporateData, leadDetails: val });
    setIsDefalut(false);
  };
  const handlePocSubmit = (val) => {
    setCorporateData({ ...corporateData, pocDetails: val });
    setIsDefalut(false);
  };
  const handleLocSubmit = (val) => {
    setCorporateData({ ...corporateData, location: val });
    setIsDefalut(false);
  };
  const handleCatSubmit = (val) => {
    setCorporateData({ ...corporateData, categoryDetails: val });
    setIsDefalut(false);
  };
  const handleGatesSubmit = (val) => {
    setCorporateData({ ...corporateData, gateDetails: val });
    setIsDefalut(false);
  };
  const handleModalHide = () => {
    setCorporateData(corporateInput);
    setIsDefalut(true);
    setIsModal(false);
  };

  useEffect(() => {
    (async () => {
      await getSampleFileLead();
    })();
  }, [getSampleFileLead]);

  const handleSubmit = () => {
    const {
      leadDetails,
      pocDetails,
      location,
      categoryDetails,
      gateDetails
    } = corporateData;
    if (
      leadDetails === null ||
      pocDetails === null ||
      location === null ||
      categoryDetails === null
    ) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        setIsLoading(true);
        const res = await createCorporateLead({
          ...leadDetails,
          ...pocDetails,
          ...location,
          ...categoryDetails,
          ...gateDetails,
        });
        setIsLoading(false);
        localStorage.removeItem('currentLocation');
        if (res === true) {
          setIsModal(true);
        }
      })();
    }
  };
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCorporateDropDown();
      setIsLoading(false);
    })();
  }, [getCorporateDropDown]);

  const handlebulkSubmit = async () => {
    if (bulkFile !== null) {
      const res = await BulkUploadLead(bulkFile);
      if (res) {
        setIsuploaded(true);
      } else {
        setIsuploaded(false);
      }
    }
  };
  const handleFileChange = (val) => {
    setBulkFile(val);
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={() => {
            setIsbulk(true);
            setIsuploaded(false);
          }}
          className="btn btn-transparent"
        >
          {localization.bulkUpload}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.createLeadCorporate}
      className={isFiled && 'requiredFileds'}
      // Buttons={headerBtns}
      isLoading={isLoading}
    >
      <LeadDetails
        inputLabel={localization.clientName}
        isCorporate={true}
        corDropDownData={corDropDownData}
        handleValue={handleLeadSubmit}
        isDefalut={isDefalut}
      />
      <PocDetails
        corDropDownData={corDropDownData}
        handleValue={handlePocSubmit}
        isDefalut={isDefalut}
      />
      <Location
        isDefalut={isDefalut}
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        showHideToast={showHideToast}
      />
      <CategoryDetails
        isSupply={false}
        handleValue={handleCatSubmit}
        supplyNameFun={supplyNameFun}
        splNameData={splNameData}
        rwaTenureFun={rwaTenureFun}
        rwaTenureData={rwaTenureData}
        corDropDownData={corDropDownData}
        isDefalut={isDefalut}
      />
      {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        isDefalut={isDefalut}
      /> */}
      <Fragment>
        <div className="btn-group">
          <Button
            onClick={handleSubmit}
            className="d-none d-md-inline-block
         d-md-none d-block xs-fullwidth btncrp"
          >
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </Fragment>

      <BulkUpload
        sampleData={sampleData && sampleData}
        handleModalHide={() => setIsbulk(!isbulk)}
        handlebulkSubmit={handlebulkSubmit}
        isbulk={isbulk}
        handleFileChange={handleFileChange}
        isUploaded={isUploaded}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.leadSuccess}</h5>
          <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          <Button onClick={handleModalHide} className="btn btn-transparent">
            {localization.createAnother}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

Corporate.propTypes = {
  LeadSource: PropTypes.func,
  sourceData: PropTypes.array,
  pocType: PropTypes.func,
  pocTypeData: PropTypes.array,
  leadCategories: PropTypes.func,
  leadCategory: PropTypes.array,
  locationCity: PropTypes.func,
  cities: PropTypes.array,
  locationZone: PropTypes.func,
  zones: PropTypes.array,
  locationArea: PropTypes.func,
  areas: PropTypes.array,
  locationType: PropTypes.func,
  locTypesData: PropTypes.array,
  locationState: PropTypes.func,
};

export default Corporate;
